"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WrappedComponent = exports.default = exports.StatusRecord = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _generalStore = require("general-store");

var _memoize = _interopRequireDefault(require("transmute/memoize"));

var _TimelineEventsDependency = _interopRequireDefault(require("crm_ui/timeline/data/dependencies/TimelineEventsDependency"));

var _getTimelineItemId = require("../../helpers/getTimelineItemId");

var _TimelineMonth = _interopRequireDefault(require("./TimelineMonth"));

var _ImmutableModel = require("customer-data-objects/model/ImmutableModel");

var _SubjectType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/SubjectType"));

var _TimelineOverrideFavoriteEventDependency = _interopRequireDefault(require("crm_ui/timeline/data/dependencies/TimelineOverrideFavoriteEventDependency"));

var _immutable = require("immutable");

var _TimelineStatusStore = _interopRequireDefault(require("crm_ui/timeline/data/stores/TimelineStatusStore"));

var _FormattedReactMessage = _interopRequireDefault(require("I18n/components/FormattedReactMessage"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _TimelineConstants = require("crm_universal/timeline/TimelineConstants");

var _TimelineFilterEngagementTypes = require("crm_ui/timeline/helpers/TimelineFilterEngagementTypes");

var _KnowledgeBaseButton = _interopRequireDefault(require("ui-addon-i18n/components/KnowledgeBaseButton"));

var _SampleContactUtils = require("crm_ui/utils/SampleContactUtils");

var _PinnedEngagementsStore = _interopRequireDefault(require("crm_ui/pinnedEngagements/stores/PinnedEngagementsStore"));

var _TimelineConstants2 = require("crm_ui/BET/timeline/TimelineConstants");

var _Map;

var StatusRecord = (0, _immutable.Record)({
  hasMore: true,
  eventCount: 0
}, 'StatusRecord');
exports.StatusRecord = StatusRecord;
var ENGAGEMENT_TYPE_TO_KNOWLEDGE_URL = (0, _immutable.Map)((_Map = {}, (0, _defineProperty2.default)(_Map, _TimelineFilterEngagementTypes.ENGAGEMENTS_NOTES, 'https://knowledge.hubspot.com/articles/kcs_article/contacts/how-do-i-mention-someone-in-the-crm'), (0, _defineProperty2.default)(_Map, _TimelineFilterEngagementTypes.ENGAGEMENTS_EMAIL, 'https://knowledge.hubspot.com/articles/kcs_article/email-tracking/connect-your-inbox-to-hubspot'), (0, _defineProperty2.default)(_Map, _TimelineFilterEngagementTypes.ENGAGEMENTS_CALLS, 'https://knowledge.hubspot.com/articles/kcs_article/calling/use-the-calling-tool'), _Map));

var TimelineEvents =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(TimelineEvents, _React$PureComponent);

  function TimelineEvents(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TimelineEvents);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TimelineEvents).call(this, props));
    _this.renderMonthOrEventWrapper = (0, _memoize.default)(_this.renderMonthOrEventWrapper.bind((0, _assertThisInitialized2.default)(_this)));
    return _this;
  }

  (0, _createClass2.default)(TimelineEvents, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$props = this.props,
          events = _this$props.events,
          onTimelineEventsChanged = _this$props.onTimelineEventsChanged;

      if (typeof onTimelineEventsChanged !== 'function') {
        return;
      }

      if (events && events.size) {
        onTimelineEventsChanged({
          target: document.querySelector('[data-three-column-scrollable-container="true"]')
        });
      }
    }
  }, {
    key: "renderMonthOrEventWrapper",
    value: function renderMonthOrEventWrapper(timelineItem, idx) {
      var _this$props2 = this.props,
          EventComponent = _this$props2.EventComponent,
          subject = _this$props2.subject,
          profileStartTime = _this$props2.profileStartTime,
          timelineLoadStartTime = _this$props2.timelineLoadStartTime;

      if (timelineItem.has('etype')) {
        return _react.default.createElement(EventComponent, {
          key: (0, _getTimelineItemId.getTimelineItemId)(timelineItem),
          timelineItem: timelineItem,
          objectType: (0, _ImmutableModel.getObjectType)(subject),
          subject: subject,
          subjectId: "" + (0, _ImmutableModel.getId)(subject),
          profileStartTime: profileStartTime,
          dataStartTime: timelineLoadStartTime
        });
      }

      return _react.default.createElement(_TimelineMonth.default, {
        isFirstMonth: idx === 0,
        key: "month_" + timelineItem.get('label'),
        label: timelineItem.get('label'),
        text: timelineItem.get('text')
      });
    }
  }, {
    key: "renderZeroStateZorseLink",
    value: function renderZeroStateZorseLink(engagementType) {
      var knowledgeBaseUrl = ENGAGEMENT_TYPE_TO_KNOWLEDGE_URL.get(engagementType);

      if (!knowledgeBaseUrl) {
        return null;
      }

      return _react.default.createElement(_KnowledgeBaseButton.default, {
        url: knowledgeBaseUrl,
        useZorse: true
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "profileContentTimeline.zeroState.learnMore"
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          PinnedEventComponent = _this$props3.PinnedEventComponent,
          events = _this$props3.events,
          favoriteEventOverride = _this$props3.favoriteEventOverride,
          subject = _this$props3.subject,
          timelineStatus = _this$props3.timelineStatus,
          pinnedEngagementId = _this$props3.pinnedEngagementId;

      if (favoriteEventOverride) {
        if (!(timelineStatus.hasMore || timelineStatus.eventCount > 0) && !(0, _SampleContactUtils.getIsSampleContact)((0, _ImmutableModel.getProperty)(subject, 'email'))) {
          var engagementType = favoriteEventOverride.get('eventTypes').first();
          var engagementTypeKey = _TimelineConstants.ENGAGEMENT_TYPE_TO_I18N_KEY[engagementType];

          if ([_TimelineConstants2.BET_CUSTOMER_SUMMARY_TAB, _TimelineConstants2.BET_RENEWAL_SUMMARY_TAB].includes(engagementType)) {
            return null;
          }

          return _react.default.createElement("div", {
            className: "text-center p-top-12"
          }, _react.default.createElement(_FormattedReactMessage.default, {
            message: "profileContentTimeline.zeroState." + engagementTypeKey,
            options: {
              learnMoreLink: this.renderZeroStateZorseLink(engagementType)
            }
          }));
        }
      }

      return _react.default.createElement(_react.Fragment, null, _react.default.createElement(PinnedEventComponent, {
        filteredEventTypes: favoriteEventOverride && favoriteEventOverride.get('eventTypes'),
        key: "pinned-note",
        objectType: (0, _ImmutableModel.getObjectType)(subject),
        pinnedEngagementId: pinnedEngagementId,
        subject: subject // for LegacyPinnedNote
        ,
        subjectId: "" + (0, _ImmutableModel.getId)(subject)
      }), events.map(this.renderMonthOrEventWrapper));
    }
  }]);
  return TimelineEvents;
}(_react.default.PureComponent);

exports.WrappedComponent = TimelineEvents;
TimelineEvents.propTypes = {
  EventComponent: _propTypes.default.func.isRequired,
  PinnedEventComponent: _propTypes.default.func.isRequired,
  onTimelineEventsChanged: _propTypes.default.func,
  profileStartTime: _propTypes.default.number,
  subject: _SubjectType.default.isRequired,
  timelineLoadStartTime: _propTypes.default.number,
  // dependencies
  events: _propTypes.default.instanceOf(_immutable.List),
  favoriteEventOverride: _propTypes.default.instanceOf(_immutable.Map),
  timelineStatus: _propTypes.default.instanceOf(StatusRecord),
  pinnedEngagementId: _propTypes.default.number
};

var _default = (0, _generalStore.connect)({
  events: _TimelineEventsDependency.default,
  favoriteEventOverride: _TimelineOverrideFavoriteEventDependency.default,
  timelineStatus: {
    stores: [_TimelineStatusStore.default],
    deref: function deref() {
      var status = _TimelineStatusStore.default.get('timelineStatus');

      return StatusRecord({
        hasMore: status.get('hasMore'),
        eventCount: status.get('events', (0, _immutable.List)()).size
      });
    }
  },
  pinnedEngagementId: {
    stores: [_PinnedEngagementsStore.default],
    deref: function deref(_ref) {
      var subject = _ref.subject;

      if (!subject) {
        return null;
      }

      var objectType = (0, _ImmutableModel.getObjectType)(subject);
      var subjectId = "" + (0, _ImmutableModel.getId)(subject);
      return _PinnedEngagementsStore.default.get((0, _immutable.Map)({
        objectType: objectType,
        subjectId: subjectId
      }));
    }
  }
})(TimelineEvents);

exports.default = _default;